import type { AttemptResult, AttemptStatus, LocalizedText } from '@jupi/shared'
import { resolveText } from '@jupi/shared'

// How the exam screens show an attempt's state.

export const RESULT_COLOR: Record<AttemptResult, 'success' | 'error' | 'warning'> = {
  pass: 'success',
  fail: 'error',
  pending: 'warning',
}

export const resultKey = (status: AttemptStatus, result: AttemptResult | null) =>
  result ? `exams.result.${result}` : `exams.status.${status}`

// A text in the reader's language, falling back as resolveText does.
export const textIn = (text: LocalizedText, language: string, fallback?: string) =>
  resolveText(text, language.slice(0, 2), fallback)

